export default {
    callable: (element: HTMLElement) => {
        createObserver();

        function createObserver() {
            let observer;

            let options = {
                root: null,
                rootMargin: '0px',
                threshold: [0.4],
            };

            observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(element);
        }

        function handleIntersect(entries: IntersectionObserverEntry[]) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0.4) {
                    (entry.target as HTMLElement).style.animationPlayState =
                        'running';
                } else {
                    (entry.target as HTMLElement).style.animationPlayState =
                        'paused';
                }
            });
        }
    },
};
